module.exports = "https://trybtryb-legacy.web.app/img/how-make-money-mobile.2d2efc61.webp";